module.exports = __webpack_public_path__ + "img/ic_map_hotel_label.8a24ff96.svg";